import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MerlineServiceService {

  private baseUrl = environment.aiIntakeUrl;

  constructor(
    private http: HttpClient
  ) { }

  // Login -> Session Generate
  createSession(payload: any): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/mcp/login`,
      payload
    );

  }

  // Chat API
  sendMessage(payload: any, sessionId?: string): Observable<any> {
    const activeSessionId = sessionId || 
      sessionStorage.getItem('merlin_session_id') || 
      localStorage.getItem('merlin_session_id') || '';

    let headers = new HttpHeaders();
    if (activeSessionId) {
      headers = headers.set('x-session-id', activeSessionId);
    }

    return this.http.post(
      `${this.baseUrl}/mcp/chat`,
      payload,
      { headers }
    );
  }

  // Logout Session
  logoutSession(sessionId: string): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/mcp/logout/${sessionId}`,
      {}
    );

  }

  // Upload Document for Parsing
  uploadDocument(formData: FormData): Observable<any> {
    return this.http.post(
      `${environment.serverUrl}/api/v1/ai-intake/upload`,
      formData
    );
  }

}
